import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
// La barra de compra móvil se importa de forma directa (no lazy) para que esté
// disponible desde el primer scroll también en la versión publicada.
import { StickyBuyBar } from './components/StickyBuyBar';

/**
 * Todo lo que está debajo del primer viewport se carga por separado para que el
 * Hero (LCP) llegue con el mínimo JS posible. Cada bloque reserva su altura
 * mientras carga, así el CLS se mantiene en cero.
 *
 * Recorrido: hero → por qué se abandona keto → las 4P (panes/pizzas/pastas/
 * postres) → los 5 bonos → para quién es → oferta → FAQ → cierre.
 */
const TransformationSection = lazy(() => import('./components/TransformationSection').then(m => ({
  default: m.TransformationSection
})));
const FlavorsSection = lazy(() => import('./components/FlavorsSection').then(m => ({
  default: m.FlavorsSection
})));
const BonosSection = lazy(() => import('./components/BonosSection').then(m => ({
  default: m.BonosSection
})));
const AudienceSection = lazy(() => import('./components/AudienceSection').then(m => ({
  default: m.AudienceSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const FinalCta = lazy(() => import('./components/FinalCta').then(m => ({
  default: m.FinalCta
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
}
function Deferred({
  children,
  minHeight,
  background = 'bg-ink'
}: DeferredProps) {
  return <Suspense fallback={<div className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="nvj5hlha6osd" />} data-id="element-0" data-mp="3dirtwl3qlz6o">
      {children}
    </Suspense>;
}
export function App() {
  return <main className="w-full bg-ink text-bone" data-id="element-2" data-mp="st2h0dmlgngm">
      <Hero data-id="element-3" data-mp="36859fxwiety" />
      <Deferred minHeight="720px" background="bg-carbon" data-id="element-4" data-mp="35yo8huu3i0e">
        <TransformationSection data-id="element-5" data-mp="38kv0f9whthk" />
      </Deferred>
      <Deferred minHeight="900px" data-id="element-6" data-mp="3udkm1tuvgq9c">
        <FlavorsSection data-id="element-7" data-mp="3ucjcxuxf2du9" />
      </Deferred>
      <Deferred minHeight="740px" data-id="element-8" data-mp="d4e4tqw8j8vn">
        <BonosSection data-id="element-9" data-mp="d3cuxpqygsfi" />
      </Deferred>
      <Deferred minHeight="520px" background="bg-carbon" data-id="element-10" data-mp="d2bjhk6123x9">
        <AudienceSection data-id="element-11" data-mp="86w76wno4g2y" />
      </Deferred>
      <Deferred minHeight="720px" data-id="element-12" data-mp="83qivjmv5i8a">
        <OfferSection data-id="element-13" data-mp="3gklb8561bk84" />
      </Deferred>
      <Deferred minHeight="700px" background="bg-carbon" data-id="element-14" data-mp="3glny8208l2ir">
        <FaqSection data-id="element-15" data-mp="3bn2z65wq0ovw" />
      </Deferred>
      <Deferred minHeight="620px" data-id="element-16" data-mp="3bo4kr4bd4trv">
        <FinalCta data-id="element-17" data-mp="3qaxrvmaqat8z" />
      </Deferred>
      <Deferred minHeight="320px" background="bg-carbon" data-id="element-18" data-mp="3qc948ai8p9bp">
        <Footer data-id="element-19" data-mp="3lkhbbtbm2rie" />
      </Deferred>
      <StickyBuyBar data-id="element-20" data-mp="3ljg27ue5of3b" />
    </main>;
}